import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ChallanLandingScreen } from './screens/ChallanLandingScreen';

export default function App() {
  return (
    <div className="appFrame">
      <BrowserRouter>
        <Routes>
          <Route path="/challans" element={<ChallanLandingScreen />} />
          <Route path="*" element={<Navigate to="/challans" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
